import * as THREE from "three";
import { createPointMarker } from "./PointMarker";
import { useFilletStore } from "../../Store/store";
import { Earcut } from "three/src/extras/Earcut.js";
// 벡터 데이터를 기반으로 폴리라인(센터라인) 업데이트 및 시각화
export function updatePolyLine(
  viewer,
  polyline,
  nodes,
  ribbonMesh,
  vehicleSpec,
  opt = {},
  edges,
  markers,
  ribbonMeshs,
  // pathEditMode,
  isDragging = false,
  // selectedMarker,
  equipmentId
) {
  const width = vehicleSpec?.width ?? 1; // 차 폭 [m]
  const wheelBase = vehicleSpec?.wheelBase ?? 2; // 축간거리 [m]
  const steeringAngle = vehicleSpec?.steeringAngle ?? 30; // 최대 조향각 [deg]
  const useFillet = opt.useFillet ?? true;

  if (nodes.length < 2) return { polyline, ribbonMesh, centerline: nodes };

  // 1) 센터라인 준비: 필렛 적용 or 원본
  let centerline;

  if (useFillet && nodes.length > 2) {
    // t1/t2/arcPoints 치환 로직
    centerline = applyFilletToPath(nodes, {
      // wheelbaseL: wheelbaseL,
      wheelBase: wheelBase,
      steeringAngle: steeringAngle,
      width: width, // 내측 붕괴 방지용 rMinWidth 반영에 사용
      segPerArc: opt.segPerArc ?? 24, // 필요하면 applyFilletToPath 내부에서 사용
      arcSteps: opt.arcSteps ?? 10, // 원호 샘플 개수(네 함수 구현에 맞춰 옵션 전달)
    });
  } else {
    centerline = nodes;
  }

  if (isDragging) {
    // 드래그 중: 기존 객체 업데이트만
    const lastPolyline = edges[edges.length - 1];
    lastPolyline.geometry.dispose();
    lastPolyline.geometry = new THREE.BufferGeometry().setFromPoints(
      centerline
    );

    const lastRibbonMesh = ribbonMeshs[ribbonMeshs.length - 1];
    lastRibbonMesh.geometry.dispose();
    const newRibbonGeometry = buildCorridor(
      centerline,
      width,
      new THREE.Vector3(0, 0, 1)
    );
    lastRibbonMesh.geometry = newRibbonGeometry.geometry;

    return;
  }

  // 2) 이전 오브젝트 정리 (지오메트리/머티리얼 누수 방지)
  if (polyline) {
    viewer.scene.scene.remove(polyline);
    polyline.geometry.dispose();
    polyline.material.dispose();
    polyline = null;
  }

  if (ribbonMesh) {
    viewer.scene.scene.remove(ribbonMesh);
    ribbonMesh.geometry.dispose();
    ribbonMesh.material.dispose();
    ribbonMesh = null;
  }

  // 3) 폴리라인 생성
  if (!polyline) {
    const geo = new THREE.BufferGeometry().setFromPoints(centerline);
    const mat = new THREE.LineBasicMaterial({ color: 0xffffff });
    polyline = new THREE.Line(geo, mat);
    polyline.userData = { type: "path-line", equipmentId: equipmentId };
    viewer.scene.scene.add(polyline);
    edges.push(polyline);

    // 회랑 메쉬 생성
    // ribbonMesh = buildCorridor(nodes, width, new THREE.Vector3(0, 0, 1));
    ribbonMesh = buildCorridor(centerline, width, new THREE.Vector3(0, 0, 1));
    if (ribbonMesh) {
      ribbonMesh.userData = { type: "path-ribbon", equipmentId: equipmentId };
      viewer.scene.scene.add(ribbonMesh);
    }
    ribbonMeshs.push(ribbonMesh);

    // 이전 요소들의 가시성 제어
    if (edges.length >= 1 && !isDragging) {
      // edges[edges.length - 2].visible = false;
      // markers[markers.length - 2].visible = false;
      // ribbonMeshs[ribbonMeshs.length - 2].visible = false;
      for (let i = 0; i < edges.length - 1; i++) {
        edges[i].visible = false;
        ribbonMeshs[i].visible = false;
      }
    }
  } else {
    polyline.geometry.dispose();
    polyline.geometry = new THREE.BufferGeometry().setFromPoints(centerline);
  }

  // 필요하면 외부에서 다시 참조할 수 있도록 반환
  // 폴리라인 : 센터라인 좌표 기반 시각화된 라인 정보
  // 회랑 메쉬 : 폭 정보 포함 메쉬
  // 센터라인 : 필렛 적용된 중심선 벡터 좌표
  return { polyline, ribbonMesh, centerline };
}

// 장애물 업데이트
// let previousPolyline = null;
// let previousPolygonMesh = null;
// let renderObjects = [];
// export function updateObstacle(viewer, points, zStatsStore) {

//   // 이전 장애물 정리
//   if (previousPolyline) {
//     viewer.scene.scene.remove(previousPolyline);
//     previousPolyline.geometry.dispose();
//     previousPolyline.material.dispose();
//     previousPolyline = null;
//   }

//   // 완성된 장애물 정리
//   if (points[0].equals(points[points.length - 1]) && points.length > 1) {
//     renderObjects = [];
//   }

//   // 점 배열이 폴리라인으로 이어진 기하체계 생성
//   const geo = new THREE.BufferGeometry().setFromPoints(points);
//   // 장애물 라인 업데이트
//   const mat = new THREE.LineBasicMaterial({ color: 0xff0000 });

//   previousPolyline = new THREE.Line(geo, mat);

//   viewer.scene.scene.add(previousPolyline);
//   renderObjects.push(previousPolyline);

//   // 완성된 장애물에 폴리곤 업데이트
//   if (points.length > 3 && points[0].equals(points[points.length - 1])) {
//     const shape = new THREE.Shape();
//     shape.moveTo(points[0].x, points[0].y);

//     for (let i = 1; i < points.length - 1; i++) {
//       shape.lineTo(points[i].x, points[i].y);
//     }

//     const geometry = new THREE.ShapeGeometry(shape);
//     const material = new THREE.MeshBasicMaterial({
//       color: 0xff0000,
//       transparent: true, // 투명도 활성화
//       opacity: 0.3, // 30% 투명도
//       side: THREE.DoubleSide,
//     });
//     previousPolygonMesh = new THREE.Mesh(geometry, material);
//     previousPolygonMesh.position.z = zStatsStore; // z축 보정
//     viewer.scene.scene.add(previousPolygonMesh);
//     renderObjects.push(previousPolygonMesh);
//   }
//   return renderObjects;
// }

function createPolygonMesh(points, color = 0xff0000, zStatsStore) {
  // 폴리곤 메쉬 커스텀
  if (points.length < 3) return null;

  // 1. 폴리곤 평면 추출
  const v1 = new THREE.Vector3().subVectors(points[1], points[0]);
  const v2 = new THREE.Vector3().subVectors(points[2], points[0]);
  const normal = new THREE.Vector3().crossVectors(v1, v2).normalize();

  // 로컬 좌표계 구성
  const xAxis = v1.clone().normalize();
  const yAxis = new THREE.Vector3().crossVectors(normal, xAxis).normalize();

  // 2. 3D -> 2D 투영
  const vertices2D = [];
  points.forEach((p) => {
    const dx = p.x - points[0].x;
    const dy = p.y - points[0].y;
    const dz = p.z - points[0].z;
    const localX = dx * xAxis.x + dy * xAxis.y + dz * xAxis.z;
    const localY = dx * yAxis.x + dy * yAxis.y + dz * yAxis.z;
    vertices2D.push(localX, localY);
  });

  // 3. Earcut triangulation
  const indices = Earcut.triangulate(vertices2D, null, 2);
  const avgZ = points.reduce((sum, p) => sum + p.z, 0) / points.length;
  // 4. BufferGeometry 생성
  const geometry = new THREE.BufferGeometry();
  const vertices3D = [];
  points.forEach((p) => {
    vertices3D.push(p.x, p.y, p.z - avgZ + zStatsStore);
  });

  geometry.setAttribute(
    "position",
    new THREE.Float32BufferAttribute(vertices3D, 3)
  );
  geometry.setIndex(indices);
  geometry.computeVertexNormals();

  // 5. 재질
  const material = new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity: 0.5,
    side: THREE.DoubleSide,
    depthWrite: false,
    depthTest: true,
  });

  const mesh = new THREE.Mesh(geometry, material);
  mesh.renderOrder = 999;

  return mesh;
}

export function updateObstacle(
  viewer, // 뷰어
  points, // 장애물 좌표 배열
  obstacleId, // 장애물 영역 고유 식별자
  selectedAreaColor // 장애물 색상
) {
  if (points.length < 2) return;

  // 이전 장애물 정리
  const childrenToRemove = [];
  viewer.scene.scene.children.forEach((child) => {
    if (
      child.userData?.obstacleId === obstacleId &&
      child.userData?.type === "temp-line"
    ) {
      childrenToRemove.push(child);
    }
  });

  childrenToRemove.forEach((child) => {
    viewer.scene.scene.remove(child);
    child.geometry.dispose();
    child.material.dispose();
  });
  // ----------------------------

  // const renderObjects = [];
  const renderObjects = {
    lines: [],
    polygons: [],
    all: [],
  };

  // 라인 생성
  const lineGeo = new THREE.BufferGeometry().setFromPoints(points);
  const lineMat = new THREE.LineBasicMaterial({
    color: selectedAreaColor ? selectedAreaColor : 0xff0000,
  });
  const line = new THREE.Line(lineGeo, lineMat);

  const isCompleted =
    points.length >= 4 &&
    points[0].distanceTo(points[points.length - 1]) < 0.001;

  line.userData = {
    obstacleId,
    type: isCompleted ? "final-line" : "temp-line",
    originalColor: selectedAreaColor ? selectedAreaColor : 0xff0000, // 원본 색상 저장
  }; // 생성한 THREE.js 라인 객체에 사용자 정의 정보를 저장

  viewer.scene.scene.add(line); // 뷰어에 라인 추가
  // renderObjects.push(line);

  renderObjects.lines.push(line);
  renderObjects.all.push(line);

  // 폴리곤
  if (
    points.length >= 4 &&
    points[0].distanceTo(points[points.length - 1]) < 0.001 // 첫점과 끝점이 거의 일치하는지 확인
  ) {
    const shape = new THREE.Shape();
    shape.moveTo(points[0].x, points[0].y); // 첫점으로 이동
    for (let i = 1; i < points.length; i++) {
      shape.lineTo(points[i].x, points[i].y); // 폴리곤 그리기
    }
    shape.lineTo(points[0].x, points[0].y);

    const polyGeo = new THREE.ShapeGeometry(shape); // 폴리곤 기하체계 생성
    const polyMat = new THREE.MeshBasicMaterial({
      // 폴리곤 재질 생성
      color: selectedAreaColor ? selectedAreaColor : 0xff0000,
      transparent: true,
      opacity: 0.5,

      side: THREE.DoubleSide,
    });
    const polygon = new THREE.Mesh(polyGeo, polyMat); // 폴리곤 생성
    // const polygon = createPolygonMesh(
    //   points,
    //   selectedAreaColor ? selectedAreaColor : 0xff0000,
    //   zStatsStore
    // );

    polygon.renderOrder = 999;
    polygon.position.z = points[0].z; // z축 보정 (포인트 자체에 실제 Z + 오프셋 적용됨)
    polygon.userData = { obstacleId, type: "final-polygon" }; // 장애물 ID 저장
    viewer.scene.scene.add(polygon);
    renderObjects.polygons.push(polygon); // 폴리곤 추가
    renderObjects.all.push(polygon);
  }

  return renderObjects;
}

// // 완성된 장애물 정리
// if (points[0].equals(points[points.length - 1]) && points.length > 1) {
//   renderObjects = [];
// }

// renderObjects.push(previousPolyline);

// // 완성된 장애물에 폴리곤 업데이트
// if (points.length > 3 && points[0].equals(points[points.length - 1])) {
//   const shape = new THREE.Shape();
//   shape.moveTo(points[0].x, points[0].y);

//   for (let i = 1; i < points.length - 1; i++) {
//     shape.lineTo(points[i].x, points[i].y);
//   }

//   const geometry = new THREE.ShapeGeometry(shape);
//   const material = new THREE.MeshBasicMaterial({
//     color: 0xff0000,
//     transparent: true, // 투명도 활성화
//     opacity: 0.3, // 30% 투명도
//     side: THREE.DoubleSide,
//   });
//   previousPolygonMesh = new THREE.Mesh(geometry, material);
//   previousPolygonMesh.position.z = zStatsStore; // z축 보정
//   viewer.scene.scene.add(previousPolygonMesh);
//   renderObjects.push(previousPolygonMesh);
// }
// return renderObjects;
// }

// 일정 폭을 가진 회랑(리본, 코리도) 메쉬 생성
export function buildCorridor(
  center,
  width = 1,
  up = new THREE.Vector3(0, 0, 1)
) {
  const half = width * 0.5; // 폭의 절반
  const left = [];
  const right = [];

  // 진행 방향(접선) 계산 함수
  const tangentAt = (pts, i) => {
    if (i === 0)
      return new THREE.Vector3().subVectors(pts[1], pts[0]).normalize();
    if (i === pts.length - 1)
      return new THREE.Vector3().subVectors(pts[i], pts[i - 1]).normalize();
    const a = new THREE.Vector3().subVectors(pts[i], pts[i - 1]);
    const b = new THREE.Vector3().subVectors(pts[i + 1], pts[i]);
    return a.add(b).normalize();
  };

  for (let i = 0; i < center.length; i++) {
    const p = center[i];
    const t = tangentAt(center, i); // 진행 방향
    const n = new THREE.Vector3().crossVectors(t, up).normalize(); // 좌우 방향
    left.push(
      new THREE.Vector3().addVectors(p, n.clone().multiplyScalar(+half))
    );
    right.push(
      new THREE.Vector3().addVectors(p, n.clone().multiplyScalar(-half))
    );
  }

  // 삼각 스트립 메쉬 만들기
  const N = Math.min(left.length, right.length);
  const positions = new Float32Array(N * 2 * 3);
  const indices = [];
  for (let i = 0; i < N; i++) {
    positions.set([left[i].x, left[i].y, left[i].z], 2 * i * 3);
    positions.set([right[i].x, right[i].y, right[i].z], (2 * i + 1) * 3);
  }
  for (let i = 0; i < N - 1; i++) {
    const a = 2 * i,
      b = 2 * i + 1,
      c = 2 * i + 2,
      d = 2 * i + 3;
    indices.push(a, b, c, c, b, d); // 두 삼각형
  }

  const geo = new THREE.BufferGeometry();
  geo.setAttribute("position", new THREE.BufferAttribute(positions, 3));
  geo.setIndex(indices);
  geo.computeVertexNormals();

  // 회랑 메쉬 재질 설정
  const mat = new THREE.MeshStandardMaterial({
    color: 0x7cb342,
    transparent: true,
    opacity: 0.3,
    side: THREE.DoubleSide,
  });

  return new THREE.Mesh(geo, mat);
}

// 필렛 적용 로직 ------------------------------------------------------------------------------------------------

// 1. 차량 스펙을 통한 최대 회전 반경(R) 계산
export function steeringToRadius(wheelBase, steeringAngle) {
  // 축간거리(wheelBase)과 조향각(steeringAngle)으로 회전 반경(R) 계산
  const δ = THREE.MathUtils.degToRad(steeringAngle);
  if (δ <= 0) throw new Error("steeringAngle > 0 필요");

  return wheelBase / Math.tan(δ);
}

// 2. 실제 노드 각도 대비 생성될 코너 반경 계산
export function cornerFilletRadius(
  P1,
  P2,
  P3,
  { rDesired, width, minRExtra = 0.05 }
) {
  // 노드 백터값 추출
  const v1 = new THREE.Vector3().subVectors(P1, P2);
  const v2 = new THREE.Vector3().subVectors(P3, P2);
  const len1 = v1.length();
  const len2 = v2.length();
  v1.normalize();
  v2.normalize();

  // 노드 간 각도 계산
  let cosφ = v1.dot(v2);
  cosφ = Math.min(1, Math.max(-1, cosφ));
  const φ = Math.acos(cosφ);
  const degree = THREE.MathUtils.radToDeg(φ);

  if (φ < THREE.MathUtils.degToRad(1)) return 0;

  // 반지름이 세그먼트 길이를 초과하지 않도록 제한
  // t = r * tan(φ/2) <= len1, len2  ⇒ r <= min(len1,len2) / tan(φ/2)
  const rMaxBySegment = Math.min(len1, len2) / Math.tan(φ / 2);

  // 반지름이 도로 폭의 절반보다 커야 함 (내측 붕괴 방지)
  const rMinByWidth = width > 0 ? width / 2 + minRExtra : 0;

  // 최종 반지름 결정:
  let r = Math.max(rDesired, rMinByWidth); // 최소 반지름 제한
  r = Math.min(r, rMaxBySegment); // 최대 반지름 제한

  // 만약 r이 너무 작아 클램프되어도 φ가 매우 작으면(완만) 크게 문제없음.
  // r가 0이면 필렛 생략.
  // isFinite(r) : r이 유한한 값인지 확인
  return isFinite(r) && r > 0 ? r : 0;
}

// 3. 필렛이 적용된 센터라인의 벡터 좌표를 반환
export function applyFilletToPath(points, vehicleSpec, viewer) {
  const newPoints = [];

  // 중심선 노드 반복
  for (let i = 0; i < points.length; i++) {
    const P1 = points[i - 1];
    const P2 = points[i];
    const P3 = points[i + 1];

    if (!P1 || !P3) {
      newPoints.push(P2); // 경계점은 그대로 추가
      continue;
    }

    // 최대 회전 반경 계산
    // const R = steeringToRadius(vehicleSpec.wheelbaseL, vehicleSpec.steerDeg);
    const R = steeringToRadius(
      vehicleSpec.wheelBase,
      vehicleSpec.steeringAngle
    );
    // 코너 반경 계산
    const r = cornerFilletRadius(P1, P2, P3, {
      rDesired: R,
      width: vehicleSpec.width,
    });

    // 코너 반경이 0보다 크면 필렛 적용
    if (r > 0) {
      // --- 벡터 계산 ---
      const v1 = new THREE.Vector3().subVectors(P1, P2).normalize();
      const v2 = new THREE.Vector3().subVectors(P3, P2).normalize();

      const phi = Math.acos(v1.dot(v2)); // 코너 각도(라디안 값)
      const degrees = THREE.MathUtils.radToDeg(phi); // 정확한 각도로 변환

      // P2 기준 양쪽 접점까지 거리
      const t = r / Math.tan(phi / 2);

      // t1, t2 (접점 좌표)
      const t1 = new THREE.Vector3().copy(P2).add(v1.multiplyScalar(t));
      const t2 = new THREE.Vector3().copy(P2).add(v2.multiplyScalar(t));

      // --- 원호 중심 ---
      const bisector = new THREE.Vector3().addVectors(v1, v2).normalize();
      const centerDist = r / Math.sin(phi / 2);
      const center = new THREE.Vector3()
        .copy(P2)
        .add(bisector.multiplyScalar(centerDist));

      // --- 원호 구간 ---
      const startAngle = Math.atan2(t1.y - center.y, t1.x - center.x);
      const endAngle = Math.atan2(t2.y - center.y, t2.x - center.x);

      // 시계/반시계 방향 판단
      let sweep = endAngle - startAngle;
      if (sweep > Math.PI) sweep -= Math.PI * 2; // 긴 호를 짧은 호로
      if (sweep < -Math.PI) sweep += Math.PI * 2; // 음수도 처리

      const arcPoints = [];
      const steps = 10; // 곡선을 몇개 점으로 나눌지
      for (let k = 0; k <= steps; k++) {
        const θ = startAngle + (sweep * k) / steps;
        const x = center.x + r * Math.cos(θ);
        const y = center.y + r * Math.sin(θ);
        arcPoints.push(new THREE.Vector3(x, y, P2.z));
      }

      // --- 최종 삽입 ---
      newPoints.push(t1, ...arcPoints, t2);
    } else {
      // 필렛 불필요 → 그냥 원래 P2 삽입
      newPoints.push(P2);
    }
  }

  return newPoints;
}
